var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-2 d-flex pl-4 border-right" }, [
        _vm._m(0),
        _c("div", { staticClass: "ml-4" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Año Académico: ")]
          ),
          _c("span", { staticClass: "color-black font-16 font-weight-bold" }, [
            _c("strong", [_vm._v(_vm._s(_vm.emptyText(_vm.info.academicYear)))])
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("header-item", {
            attrs: {
              "has-edit": _vm.userHasPermissions("scolarship.budget"),
              icon: "fas fa-calculator color-secondary-22",
              "label-class": "font-weight-bold color-black",
              title: "Presupuesto",
              value: _vm._f("price")(_vm.emptyValue(_vm.info.budget))
            },
            on: {
              "on-edit": function($event) {
                return _vm.$emit("on-edit", _vm.info)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("header-item", {
            attrs: {
              icon: "fas fa-check-circle color-secondary-2",
              "label-class": "font-weight-normal color-secondary-6",
              text: "color: red",
              title: "Pagado",
              value: _vm._f("price")(_vm.emptyValue(_vm.info.paid))
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("header-item", {
            attrs: {
              icon: "fas fa-clock color-yellow-star",
              "label-class": "font-weight-normal color-secondary-6",
              title: "Actual",
              value: _vm._f("price")(_vm.emptyValue(_vm.info.actual))
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("header-item", {
            attrs: {
              icon: "fas fa-chart-line color-orange",
              "label-class": "font-weight-normal color-secondary-6",
              title: "Proyectado",
              value: _vm._f("price")(_vm.emptyValue(_vm.info.projected))
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("header-item", {
            attrs: {
              icon: "fas fa-check-circle color-green",
              "label-class": _vm.evalAvailableColor(_vm.info.available),
              title: "Disponible",
              value: _vm._f("price")(_vm.emptyValue(_vm.info.available))
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "dot text-center d-flex justify-content-center align-items-center mt-1"
      },
      [_c("em", { staticClass: "fas fa-calendar-week color-white font-14" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }